export default __webpack_public_path__ + "static/media/NotoSansJP-Regular.888811d5.ttf";